import React, { FunctionComponent } from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { Image as DatoImage } from 'react-datocms';
import { IImage } from '../declarations/index';

import * as s from './img.module.scss';

export interface IImgStyles {
  img?: string | null;
}

export interface IImageProps extends IImage {
  styles?: IImgStyles | null;
  gatsbyImageData?: IGatsbyImageData | null;
  responsiveImage?: IGatsbyImageData | null;
  width?: number;
  height?: number;
  loading?: 'eager' | 'lazy';
}

const Image: FunctionComponent<IImageProps> = ({
  fluid,
  url,
  alt,
  className,
  format,
  styles,
  gatsbyImageData,
  responsiveImage,
  width,
  height,
  loading,
  ...props
}) => {
  const isSVG = format === 'svg' || false;
  const imageClass = !isSVG ? styles?.img || s.img : '';
  if (gatsbyImageData) {
    return (
      <GatsbyImage
        alt={alt || ''}
        image={gatsbyImageData}
        className={`${imageClass} ${className || ''}`}
        loading={loading || 'lazy'}
        {...props}
      />
    );
  }
  if (responsiveImage) {
    return <DatoImage data={responsiveImage} className={`${imageClass} ${className ?? ''}`} {...props} />;
  }
  if (url) {
    return (
      <img
        data-testid="no-fluid-image"
        src={url}
        alt={alt}
        loading={loading || 'lazy'}
        className={`${imageClass} ${className || ''}`}
        width={width}
        height={height}
        {...props}
      />
    );
  } else {
    return null;
  }
};

export default Image;
